<template>
  <div class="user-container">
    <div class="page-header">
      <img class="header-img" src="@/assets/images/home.png" alt="" @click="toHome">
      <div class="nav-title">
        <span>{{ $t('shared.title.ros') }}</span>
      </div>
      <img class="logout-img" src="@/assets/images/tuichu.png" alt="" @click="logoutFn">
    </div>
    <div class="user-card">
      <van-cell>
        <template #icon>
          <img
            src="@/assets/images/avatar.png"
            alt="avatar"
            class="avatar">
        </template>
        <template #title>
          <div class="user-info">
            <span class="username txt-ellipsis" v-if="userInfo.user">{{ userInfo.user.nickName }}</span>
            <!-- <span class="username txt-ellipsis" v-if="userInfo.user.dept">{{ userInfo.user.dept.label }}</span> -->
          </div>
        </template>
        <template #right-icon>
          <!-- <img class="logout-img" src="@/assets/images/tuichu.png" alt="" @click="logoutFn"> -->
        </template>
      </van-cell>
    </div>
    <UserFilter
      ref="userFilterRef"
      pageType="mapping"
      :multiple="true"
      :dataOptions="userOptions"
      :isScopeUser="true"
      :fieldNames="{label: 'nickName', value: 'id'}"
      @filter-change="onFilterChange"
    />
    <div class="sub-filter">
      <div class="filter-left">
        <div class="total-count">{{ $t('form.total') }}：{{ totalCount }} {{ $t('shared.records') }}, </div>
        <div class="total-count">{{ storesCount }} {{ $t('shared.stores') }}, {{ sdCount }} {{ $t('shared.distributor') }}</div>
      </div>
      <van-checkbox v-model="isHide" shape="square" @change="handleOper">{{ $t('shared.hideUpdate') }}</van-checkbox>
    </div>
    <div class="user-main-content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="No more data" @load="onLoad" :immediate-check="false">
          <div class="activity-item" v-for="(item, index) in userList" :key="index" @click="toUrl(item)">
            <div class="info-title">
              <div class="activity-type">
                <span class="type-label">{{ item.label | formatType }}</span>
                {{ activityTypeInfo[item.activityType] }}<span v-if="item.expandInfoJson">{{ item.expandInfoJson | formatExpandInfoJson({activityType: item.activityType }) }}</span>
                <!-- <span v-if="item.activityType === 60 && item.expandInfoJson">{{ item.expandInfoJson.user.nickName }}</span>
                <span v-if="item.activityType === 15 && item.expandInfoJson">{{ item.expandInfoJson.customerTag.newCustomerTag | formatTag }}</span> -->
              </div>
              <img v-if="item.isSale" class="mark-img" src="@/assets/images/product_promotion_img.png" alt="">
            </div>
            <div class="store-info">
              <img v-if="[0, 1].includes(item.module)" src="@/assets/images/store.png" class="row-icon" />
              <img v-else src="@/assets/images/sd.png" class="row-icon" />
              <span class="store-name van-ellipsis">{{ item.operationName }}</span>
            </div>
            <div class="info-desc">
              <div>{{ item.localCreateTime }}</div>
              <div>{{ item.createUserName }}</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Dialog, Toast } from 'vant'
import { logoutAPI } from '@/api/login'
import { activityLogPageApi, dataScopeUserGroupApi } from '@/api/user'
import UserFilter from './UserFilter'
import moment from 'moment'
import i18n from '@/i18n'
export default {
  name: 'User',
  components: {
    UserFilter
  },
  filters: {
    formatType (val) {
      return val === 0 ? i18n.t('shared.mapping') : val === 1 ? i18n.t('form.popUp') : val === 2 ? i18n.t('shared.title.incentive') : val === 3 ? i18n.t('shared.visit') : val === 4 ? i18n.t('shared.visitSellIn') : val === 5 ? i18n.t('shared.reorder') : val === 6 ? i18n.t('shared.transferAllocation') : val === 7 ? i18n.t('shared.kickOutOfOperation') : val === 8 ? i18n.t('shared.mapping') : val === 9 ? i18n.t('form.brandDay') : val === 10 ? i18n.t('shared.visitSellIn') : val === 11 ? i18n.t('shared.schedule') : ''
    },
    formatExpandInfoJson (val, params) {
      if (params.activityType === 60) {
        return val.user.nickName
      } else if (params.activityType === 15) {
        const newCustomerTag = val.customerTag.newCustomerTag
        return newCustomerTag === 0 ? i18n.t('shared.filter.toBeVerified') : newCustomerTag === 1 ? i18n.t('shared.filter.sVIPCore') : newCustomerTag === 2 ? i18n.t('shared.filter.vIPCore') : newCustomerTag === 3 ? i18n.t('shared.filter.potential') : ''
      } else if ([1101, 1102].includes(params.activityType)) {
        return val.scheduleTime
      }
      return ''
    }
  },
  data () {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      labelType: '',
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      userList: [],
      userIdList: [],
      activityTypeInfo: {
        1: this.$t('shared.addNewStoreMapping'), // 新增门店Mapping
        2: this.$t('shared.updateStoreMappingInformation'), // 更新门店Mapping信息
        3: this.$t('shared.setStoreLabels'), // 设置门店标签
        10: this.$t('shared.launchPopUpEvent'), // 提报 Pop up
        11: this.$t('shared.updatePopUpEvent'), // 提报 Pop up
        12: this.$t('shared.cancelPopUpEvent'), // 取消 Pop up
        13: this.$t('shared.reportPopUpEventExecutionStatus'),
        14: this.$t('shared.sellOutDataMaintenance'), // Pop up 执行情况上报
        15: this.$t('shared.setStoreTag'), // 设置门店标签
        17: this.$t('shared.materialSampleDeliveryDataMaintenance'),
        20: this.$t('shared.storeIncentiveInviteEmployeeToActivate'), // Store Incentive 邀约员工开通
        21: this.$t('shared.storeIncentiveDeactivateEmployeeAccount'), // Store Incentive 关闭员工账号
        22: this.$t('shared.storeIncentiveBindProduct'), // Store Incentive 绑定产品
        23: this.$t('shared.storeIncentiveUploadSalesProof'), // Store Incentive 上传销售凭证
        24: this.$t('shared.redeemIncentiveRewardsForEmployees'),
        30: this.$t('shared.addNewStoreVisit'), // 新增门店拜访
        31: this.$t('shared.updateStoreVisitInformation'), // 更新门店拜访信息
        32: this.$t('shared.setStoreTag'),
        40: this.$t('shared.newVisitSellIn'),
        41: this.$t('shared.updateVisitSellIn'),
        50: this.$t('shared.newReOrder'),
        51: this.$t('shared.modifyReOrder'),
        60: this.$t('shared.storesAreTransferredAndAllocatedTo'), // 门店转移并分配给
        61: this.$t('shared.cancelAllocationOfStores'), // 取消分配门店
        62: this.$t('shared.setAssignedBABDInTheManagementSystem'), // '后台设置负责人 ',
        71: this.$t('shared.aplyToKickOutOfOperation'),
        72: this.$t('shared.agreeToApplicationForKickOutOfOperation'),
        73: this.$t('shared.rejectApplicationForKickingOutUpStore'),
        81: this.$t('shared.newDistributorMapping'),
        82: this.$t('shared.updateDistributorMapping'),
        83: this.$t('shared.setTheResponsiblePerson'), // '设置负责人 ',
        90: this.$t('shared.brandDayApplication'),
        91: this.$t('shared.modifyBrandDayApplicationInfo'),
        92: this.$t('shared.cancelBrandDay'),
        93: this.$t('shared.reportingOnTheBrandDayExecution'),
        1001: this.$t('shared.newDistributorVisit'),
        1002: this.$t('shared.updateDistributorVisit'),
        1101: this.$t('shared.addNewVisitSchedulePlannedVisitDate'),
        1102: this.$t('shared.cancelVisitSchedule')
      },
      isHide: false,
      totalCount: 0,
      storesCount: 0,
      sdCount: 0,
      userOptions: []
    }
  },
  computed: {
    ...mapState({
      userInfo: 'myUserInfo',
      globalData: 'globalData'
    })
  },
  // created() {
  //   this.currentDate = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // },
  created () {},
  activated () {
    if (!this.isNavigateTo) {
      this.getUserData()
    }
    this.isNavigateTo = false
  },
  beforeRouteLeave (to, from, next) {
    if (['/createEvent', '/eventDetail', '/storeIncentive', '/incentive/incentiveDetail', '/pointsDetail', '/storeMaintain/storeVisitDetail', '/storeExpansion/visitSellInDetail', '/storeMaintain/reOrderVisitDetail', '/storeExpansion/storeMappingDetail', '/storeMaintain/storeMappingDetail', '/salesDistribution/sdMappingDetail', '/salesDistribution/sdVisitDetail'].includes(to.path)) {
      this.isNavigateTo = true
    }
    next()
  },
  // deactivated () {
  //   this.$destroy()
  // },
  methods: {
    ...mapMutations(['setToken']),
    ...mapMutations('event', ['SET_EVENTINFO']),
    getUserData () {
      dataScopeUserGroupApi().then(res => {
        res.data.forEach(subItem => {
          subItem.checkId = 0
        })
        this.userOptions = res.data
        if (this.checkPer(['admin', 'app:user:searchUser'])) {
          this.$nextTick(() => {
            this.$refs.userFilterRef.resetAllFilter()
          })
        } else {
          this.$nextTick(() => {
            this.$refs.userFilterRef.resetAllFilter()
          })
        }
      })
    },
    onFilterChange (data) {
      this.labelType = data.product
      this.startDate = data.startDate
      this.endDate = data.endDate
      this.userIdList = data.userIdList
      this.onRefresh()
    },
    onRefresh () {
      this.finished = false
      this.loading = true
      this.page = 1
      this.onLoad()
    },
    onLoad () {
      // Mock API call
      if (this.refreshing) {
        this.userList = []
        this.refreshing = false
      }
      const data = {
        page: this.page,
        limit: 10,
        label: this.labelType,
        startTime: this.startDate,
        endTime: this.endDate,
        userIdList: this.userIdList.length <= 0 ? [this.userInfo.user.id] : this.userIdList,
        isHide: this.isHide
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      activityLogPageApi(data).then(res => {
        Toast.clear()
        if (this.page === 1) {
          this.userList = res.data.page.list
        } else {
          this.userList = [...this.userList, ...res.data.page.list]
        }
        this.loading = false
        this.page++
        this.totalCount = Number(res.data.page.totalRow)
        this.storesCount = res.data.storeCount
        this.sdCount = res.data.sdCount
        if (this.userList.length >= Number(res.data.page.totalRow)) {
          this.finished = true
        }
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },
    toUrl (params) {
      if ([10, 11].includes(params.activityType)) {
        this.$router.push(`/createEvent?eventId=${params.sourceId}&pageType=store&eventType=1`)
      } else if ([90, 91].includes(params.activityType)) {
        this.$router.push(`/createEvent?eventId=${params.sourceId}&pageType=salesDistribution&eventType=2`)
      } else if ([12, 92].includes(params.activityType)) {
        Toast('Event Cancelled')
      } else if ([13, 14, 15, 17, 93].includes(params.activityType)) {
        this.SET_EVENTINFO({ eventId: params.sourceId, schedule: '' })
        this.$router.push(`/eventDetail?eventId=${params.sourceId}&pageType=`)
      } else if ([20, 21].includes(params.activityType)) {
        this.$router.push(`/storeIncentive?customerId=${params.operationId}`)
      } else if ([22, 23].includes(params.activityType)) {
        this.$router.push(`/incentive/incentiveDetail?scanId=${params.sourceId}`)
      } else if (params.activityType === 24) {
        this.$router.push(`/pointsDetail?employeeId=${params.createUserId}&customerId=${params.sourceId}`)
      } else if ([30, 31, 32].includes(params.activityType)) {
        this.$router.push(`/storeMaintain/storeVisitDetail?visitId=${params.sourceId}`)
      } else if ([40, 41].includes(params.activityType)) {
        this.$router.push(`/storeExpansion/visitSellInDetail?visitId=${params.sourceId}`)
      } else if ([50, 51].includes(params.activityType)) {
        this.$router.push(`/storeMaintain/reOrderVisitDetail?visitId=${params.sourceId}`)
      } else if ([1, 2, 60, 61, 62].includes(params.activityType)) {
        this.$router.push(`/storeExpansion/storeMappingDetail?customerId=${params.sourceId}&isRecord=record`)
      } else if ([71, 72, 73].includes(params.activityType)) {
        this.$router.push(`/storeMaintain/storeMappingDetail?customerId=${params.operationId}&pageType=storeMaintain&activityType=${params.activityType}`)
      } else if ([81, 82, 83].includes(params.activityType)) {
        this.$router.push(`/salesDistribution/sdMappingDetail?customerId=${params.sourceId}`)
      } else if ([1001, 1002].includes(params.activityType)) {
        this.$router.push(`/salesDistribution/sdVisitDetail?visitId=${params.sourceId}`)
      } else if ([1101, 1102].includes(params.activityType)) {
        this.$router.push(`/visitPlan/detail?planId=${params.sourceId}`)
      }
    },
    // 登录退出
    logoutFn () {
      Dialog.confirm({
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('button.cancel'),
        message: this.$t('tips.areYouSureToExit')
      })
        .then(() => {
          logoutAPI().then(res => {
            // 1. 清除token（vuex和本地）
            this.setToken('')
            this.$router.replace('/login')
            this.$store.commit('setToken', '')
            this.$store.commit('setUSERINFO', {})
            localStorage.removeItem('myUserInfo')
            localStorage.removeItem('storeTotal')
            localStorage.removeItem('globalData')
            localStorage.removeItem('materialDelivery')
            window.localStorage.removeItem('firstMap')
            //  2. 跳转到登录页
          })
        })
        .catch(() => {

        })
    },
    toHome () {
      this.$router.push('/homePage')
      this.userList = []
      // this.$destroy()
    },
    handleOper (val) {
      this.onRefresh()
    }
  }
}
</script>

<style scoped lang="less">
.user-container {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  height: 100%;
  background-color: #fff;
  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 46px;
    padding: 0 16px;
    color: #fff;
    font-size: 20px;
    // font-weight: bold;
    background-color: #307bff;
    .nav-title {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 5px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .title-info {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .logo-img {
        width: 34px;
        // height: 20px;
        margin-right: 5px;
      }
    }
    .logout-img {
      width: 26px;
      height: 26px;
    }
    .header-img {
      width: 26px;
      height: 26px;
    }
  }
  .user-card {
    background-color: #307bff;
    color: white;
    .van-cell {
      display: flex;
      align-items: center;
      background: #307bff;
      color: white;
      &::after {
        display: none;
      }
      .avatar {
        width: 60px;
        height: 60px;
        background-color: #fff;
        border-radius: 50%;
        margin-right: 10px;
      }
      .username {
        font-size: 14px;
        font-weight: bold;
      }
    }
    .user-info {
      display: flex;
      flex-direction: column;
      width: 210px;

    }
  }
  .sub-filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    background-color: #f5f5f9;
    .filter-left {
      width: 180px;
      .total-count {
        width: 180px;
        word-break: break-word;
      }
    }
  }
  .user-main-content {
    flex: 1;
    overflow-y: auto;
    .activity-item {
      background-color: #fff;
      margin-bottom: 1px; // Divider effect
      border-bottom: 1px solid #f0f0f0;
      padding: 10px;
      &:first-child {
        border-top: 1px solid #f0f0f0;
      }
      .info-title {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        font-size: 13px;
        color: #000;

        .type-label {
          display: inline-block;
          padding: 3px 5px;
          border: 1px solid #307bff;
          font-size: 12px;
          color: #307bff;
          margin-right: 5px;
        }
        .activity-type {
          flex: 1;
          margin-right: 5px;
          .tag72 {
            color: #c4200b;
          }
        }
        .mark-img {
          width: 23px;
          height: 23px;
        }
      }

      .store-info {
        display: flex;
        align-items: center;
        margin: 5px 0;
        .store-name {
          flex: 1;
          font-size: 13px;
          color: #333;
        }
      }

      .row-icon {
        width: 13px;
        height: 13px;
        margin-right: 6px;
        object-fit: contain;
      }

      .info-desc {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 13px;
        color: #7f7f7f;
      }
    }
  }
}
</style>
